// Mock data for Eletron Rastreamento website
// This file contains all mock data used throughout the application
// Will be replaced with real API calls when backend is implemented

export const mockData = {
  // Company information
  company: {
    name: "Eletron Rastreamento",
    phone: "(34) 3327-0829",
    instagram: "@eletronraster",
    email: "contato@eletronraster.com.br",
    description: "Tecnologia avançada em rastreamento veicular. Segurança, praticidade e tranquilidade para você e sua família.",
    links: {
      whatsapp: "https://wa.me/553433270829",
      instagram: "https://instagram.com/eletronraster",
      playstore: "https://play.google.com/store/apps/details?id=org.eletron.manager&hl=pt",
      appstore: "https://apps.apple.com/br/app/eletron/id6743964645",
      demo: "https://eletron.rastrear-vip.com.br/login?to=/home"
    }
  },

  // Hero section data
  hero: {
    title: "Rastreie seus veículos de onde estiver!",
    subtitle: "Segurança, tecnologia e praticidade por apenas R$50/mês.",
    primaryCTA: "Quero Rastrear Agora",
    secondaryCTA: "Ver Demonstração",
    features: [
      "Máxima Segurança",
      "Tempo Real",
      "App Mobile"
    ]
  },

  // Plans data
  plans: [
    {
      id: 1,
      name: "Plano Individual",
      price: "R$50",
      period: "/mês",
      description: "Perfeito para proprietários de um veículo",
      popular: false,
      features: [
        "Rastreamento em tempo real",
        "Histórico de rotas",
        "Relatórios básicos",
        "Suporte via WhatsApp",
        "Alertas e notificações",
        "App mobile incluído"
      ]
    },
    {
      id: 2,
      name: "Plano Empresarial",
      price: "Personalizado",
      period: "",
      description: "Solução completa para frotas empresariais",
      popular: true,
      features: [
        "Painel multi-veículos",
        "Relatórios avançados",
        "API para integração",
        "Dashboard web completo",
        "Suporte prioritário 24/7",
        "Backup em nuvem",
        "Geofencing avançado"
      ]
    }
  ],

  // Security features
  securityFeatures: [
    {
      title: "Localização em Tempo Real",
      description: "Acompanhe a posição exata do seu veículo a qualquer momento, com atualizações a cada segundo."
    },
    {
      title: "Histórico de Rotas",
      description: "Visualize todas as rotas percorridas com horários detalhados e quilometragem."
    },
    {
      title: "Alertas e Notificações",
      description: "Receba notificações instantâneas sobre movimentações, velocidade e áreas restritas."
    },
    {
      title: "Backup em Nuvem",
      description: "Todos os dados são armazenados com segurança em servidores protegidos."
    }
  ],

  // Server infrastructure features
  serverFeatures: [
    {
      title: "Servidores Monitorados 24/7",
      description: "Infraestrutura robusta com monitoramento contínuo para garantir 99.9% de uptime.",
      highlight: "99.9% Uptime"
    },
    {
      title: "Atendimento Automatizado Rápido",
      description: "Sistema de resposta automática para situações comuns, com resolução em segundos.",
      highlight: "< 30s"
    },
    {
      title: "Suporte Humano Presente",
      description: "Equipe técnica especializada disponível para atendimento personalizado e cordial.",
      highlight: "24/7"
    },
    {
      title: "Tonalidades de Emergência",
      description: "Protocolos especiais ativados automaticamente em situações críticas e emergenciais.",
      highlight: "Emergência"
    }
  ],

  // Statistics
  stats: {
    availability: "99.9%",
    responseTime: "< 1s",
    monitoring: "24/7",
    activeVehicles: "1000+"
  },

  // App download info
  appInfo: {
    name: "Eletron Rastreamento",
    rating: 4.8,
    downloads: "1000+",
    features: [
      "Rastreamento em tempo real",
      "Notificações push instantâneas",
      "Interface otimizada para mobile",
      "Funciona offline para consultas"
    ]
  },

  // Vehicle tracking demo data
  vehicleDemo: {
    model: "Honda Civic",
    plate: "ABC-1234",
    status: "Parado",
    location: "Rua das Flores, 123",
    lastUpdate: "agora",
    stats: {
      time: "15:30",
      distance: "45 km",
      alerts: "0"
    }
  },

  // Footer links
  footerLinks: {
    services: [
      "Rastreamento Individual",
      "Gestão de Frotas",
      "Relatórios Avançados",
      "API de Integração"
    ],
    support: [
      "Central de Ajuda",
      "Tutorial do App",
      "Contato Técnico",
      "Status dos Serviços"
    ],
    legal: [
      "Termos de Uso",
      "Política de Privacidade",
      "Cookies"
    ]
  }
};

// Mock API functions (to be replaced with real API calls)
export const mockAPI = {
  // Get company information
  getCompanyInfo: () => {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(mockData.company);
      }, 500);
    });
  },

  // Get plans
  getPlans: () => {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(mockData.plans);
      }, 300);
    });
  },

  // Subscribe to plan
  subscribeToPlan: (planId) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          success: true,
          message: "Inscrição realizada com sucesso!",
          planId: planId
        });
      }, 1000);
    });
  },

  // Contact form submission
  submitContact: (contactData) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          success: true,
          message: "Mensagem enviada com sucesso! Entraremos em contato em breve."
        });
      }, 800);
    });
  },

  // Request demo
  requestDemo: () => {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          success: true,
          message: "Demo solicitada! Entraremos em contato para agendar."
        });
      }, 600);
    });
  }
};